import React from "react"

import "../style/style.scss"
import PrivacyPolicy from "../components/PrivacyPolicy"

const PrivacyPolicyPage = () => <PrivacyPolicy />

export default PrivacyPolicyPage
